import { makeStyles } from 'tss-react/mui';
export const useStyles = makeStyles()((theme) => ({
    root: {
        minHeight: '100%',
        padding: theme.spacing(0, 6),
        fontFamily: 'Inter, "Helvetica Neue", Arial, sans-serif',
        fontSize: 13,
        color: theme.palette.grey[400],
        backgroundColor: theme.palette.grey[900],
    },
    logo: {
        margin: theme.spacing(6, 0, 2),
        svg: {
            display: 'block',
        },
    },
    body: {
        flexGrow: 1,
        h1: {
            paddingBottom: theme.spacing(2),
            margin: theme.spacing(6, 0, 2),
            color: theme.palette.grey[50],
            fontSize: 18,
            fontWeight: 400,
            lineHeight: 'normal',
            borderBottom: `1px solid ${theme.palette.grey[200]}40`,
        },
        p: {
            fontSize: 13,
            fontWeight: 400,
            lineHeight: 'normal',
        },
        a: {
            color: theme.palette.grey[50],
            '&:hover': {
                color: '#007cb5',
            },
        },
    },
    footer: {
        padding: theme.spacing(4, 0, 3),
        borderTop: `1px solid ${theme.palette.grey[200]}40`,
        svg: { display: 'block' },
    },
}));
//# sourceMappingURL=LoginSideBar.styles.js.map